import { useReducer } from "react";
import api from "../api/organizations";

const intialState = {
    createdNewPerson: null,
    staff: []
};

function reducer(state, action) {
    switch (action.type) {
        case "CREATE_NEW":
            return {
                ...state,
                createdNewPerson: action.createdNewPerson
            };
        case "GET_STAFF":
            return {
                ...state,
                staff: action.staff
            };
        default:
            return {
                ...state,
                ...action.payload
            };
    }
}

export default function useCreatePerson() {
    const [createData, dispatch] = useReducer(reducer, intialState);

    function createNewPerson(orgId, data) {
        api.createNewPerson(orgId, data).then(({ data }) => {
            //console.log(data);
        });
    }

    function addExistingPerson(orgId, personData) {
        api.addExistingPerson(orgId, personData).then(({ data }) => {
            //console.log(data);
        });
    }

    function getStaff(orgId, depId) {
        api.getOrganizationStaff(orgId, depId).then(({ data }) => {
            dispatch({
                type: "GET_STAFF",
                staff: data
            })
        });
    }

    return {
        createData,
        createNewPerson,
        addExistingPerson,
        getStaff
    };
}
